import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authApi, setToken, getToken, formatApiErrorDetail } from "@/lib/api";
import { ArrowRight, Lock } from "lucide-react";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!getToken()) return;
    authApi
      .get("/auth/me")
      .then(() => navigate("/admin", { replace: true }))
      .catch(() => {});
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await authApi.post("/auth/login", { email, password });
      setToken(data.access_token);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-3 mb-12">
          <img src="/brand/groundup-logo-light.png" alt="GroundUp Lending" className="h-10 w-auto" />
        </a>

        <div className="border border-neutral-800 bg-[#171717] p-8 md:p-10">
          <div className="flex items-center gap-3 mb-2">
            <Lock size={18} className="text-[#22C55E]" />
            <div className="label-overline text-neutral-400">Admin Access</div>
          </div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold mb-8 tracking-tight">Sign in</h1>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="label-overline text-neutral-400 mb-2 block">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="info@grounduplending.com"
                data-testid="admin-email"
              />
            </div>
            <div>
              <label className="label-overline text-neutral-400 mb-2 block">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                placeholder="••••••••"
                data-testid="admin-password"
              />
            </div>

            {error && (
              <div className="border border-red-700 bg-red-950/30 text-red-300 text-sm px-4 py-3" data-testid="admin-login-error">
                {error}
              </div>
            )}

            <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
              {loading ? "Signing in…" : "Sign In"} <ArrowRight size={16} />
            </button>
          </form>
        </div>

        <a href="/" className="block text-center mt-6 text-sm text-neutral-500 hover:text-[#22C55E] transition-colors">
          ← Back to website
        </a>
      </div>
    </div>
  );
};

export default AdminLogin;
